"use client";

import { motion, useInView, type HTMLMotionProps } from "framer-motion";
import { useRef, type ReactNode } from "react";

type AnimatedSectionProps = HTMLMotionProps<"section"> & {
  children: ReactNode;
  delay?: number;
  yOffset?: number;
};

export default function AnimatedSection({
  children,
  delay = 0,
  yOffset = 40,
  ...props
}: AnimatedSectionProps) {
  const ref = useRef<HTMLElement | null>(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <motion.section
      ref={ref}
      initial={{ opacity: 0, y: yOffset }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: yOffset }}
      transition={{ duration: 0.8, delay, ease: "easeOut" }}
      {...props}
    >
      {children}
    </motion.section>
  );
}
